import VueSvgInlinePlugin from "vue-svg-inline-plugin"

export default { 
    install: (app) => {
        app.use(VueSvgInlinePlugin)
    }
}
  